import { Fragment, VFC } from 'react';
import { FormItemProps } from 'components/Form/FormItem';
import { GasMeterDetailField } from './constants';
import { AdditionalGasDetails, getGasDetailFormItem } from './utils/getDetailFormItem';

interface GasDetailsProps {
  itemsConfig: Partial<
    Record<
      GasMeterDetailField,
      {
        formItemProps?: FormItemProps;
        additionalConfig?: AdditionalGasDetails;
      }
    >
  >;
}

export const GasDetails: VFC<GasDetailsProps> = ({ itemsConfig }) => {
  return (
    <>
      {Object.entries(itemsConfig).map(([item, { additionalConfig = {}, formItemProps = {} }]) => (
        <Fragment key={item}>
          {getGasDetailFormItem(item as GasMeterDetailField, formItemProps, additionalConfig)}
        </Fragment>
      ))}
    </>
  );
};
